import { render, staticRenderFns } from "./ExamItem.vue?vue&type=template&id=0fab743d&"
import script from "./ExamItem.vue?vue&type=script&lang=js&"
export * from "./ExamItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fab743d')) {
      api.createRecord('0fab743d', component.options)
    } else {
      api.reload('0fab743d', component.options)
    }
    module.hot.accept("./ExamItem.vue?vue&type=template&id=0fab743d&", function () {
      api.rerender('0fab743d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/ExamItem.vue"
export default component.exports